import React from 'react';
import TouchLink from '../../components/TouchLink';

const LoginNav = React.createClass({
	render(){

		const step = this.props.step;
		const title = this.props.title;
		if(title === "Book") {
			return (
				<div className="signup-header">
					<h3 className="signup-header-head">{title}</h3>
				</div>
			);
		}else {
			return (
				<div className="signup-header">
					<h3 className="signup-header-head">{title}</h3>
					<ol className={'signup-header-progress step-' + step}>
						<li className="progress-item item-profile"></li>
						<li className="progress-item item-school"></li>
						<li className="progress-item item-done"></li>
					</ol>
				</div>
			);
		}
	}
});
export default LoginNav;


/** WEBPACK FOOTER **
 ** ./src/components/SignupHeader/SignupHeader.js
 **/